// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"dab80268","719":"dab80268"}[chunkId] + ".css";
};